import { Translate } from 'next-translate'

import { Navigation } from '../ts'

function getNavigation(t: Translate): Navigation[] {
  return [
    {
      category: t('about_fansi'),
      routes: [{ name: t('how_fansi_works'), path: '/help' }],
    },
    {
      category: t('fansi_account'),
      routes: [
        { name: t('sign_in_and_sign_up'), path: '/help/signin-and-signup' },
        { name: t('my_account'), path: '/help/my-account' },
        { name: t('become_a_creator'), path: '/help/become-a-creator' },
      ],
    },
    {
      category: t('shopping_in_fansi'),
      routes: [
        { name: t('payments'), path: '/help/payments' },
        { name: t('shopping_in_fansi'), path: '/help/shopping-in-fansi' },
        { name: t('delivery_methods_and_time'), path: '/help/delivery' },
        {
          name: t('returns_and_complaints'),
          path: '/help/returns-and-complaints',
        },
        { name: t('fansi_class'), path: '/help/fansi-class' },
        { name: t('fansi_video'), path: '/help/fansi-video' },
        { name: t('fansi_collections'), path: '/help/fansi-collections' },
        { name: t('digital_products'), path: '/help/digital-products' },
        { name: t('discounts'), path: '/help/discounts' },
        { name: t('vouchers'), path: '/help/vouchers' },
      ],
    },
  ]
}
export default getNavigation
